export default __webpack_public_path__ + "static/media/rc_logo.0e82b9e1.png";